import { MAX_IMAGE_DIMENSION } from '@/constants/file'

export type ImageDimensionValidationResult = 'valid' | 'too-large' | 'unreadable'

export const validateImageDimensions = (file: File): Promise<ImageDimensionValidationResult> => {
  const objectUrl = URL.createObjectURL(file)

  return new Promise((resolve) => {
    const image = new Image()

    const finish = (result: ImageDimensionValidationResult) => {
      URL.revokeObjectURL(objectUrl)
      resolve(result)
    }

    image.onload = () => {
      const isWithinDimensionLimit =
        image.naturalWidth <= MAX_IMAGE_DIMENSION && image.naturalHeight <= MAX_IMAGE_DIMENSION

      finish(isWithinDimensionLimit ? 'valid' : 'too-large')
    }
    image.onerror = () => finish('unreadable')
    image.src = objectUrl
  })
}
